export const  assetsUrl = 'https://show.originqc.com.cn/prod/quantum_cloud/webAppAssetsFiles/';
export const  assetsUrlFont = 'https://show.originqc.com.cn/prod/quantum_cloud/webAppAssetsFiles/assets/fonts/';
export const  assetsUrlImage = 'https://show.originqc.com.cn/prod/quantum_cloud/webAppAssetsFiles/assets/images/';
export const  assetsUrlPlugins = 'https://show.originqc.com.cn/prod/quantum_cloud/webAppAssetsFiles/assets/plugins/';

export const  assetsVideoUrl = 'https://show.originqc.com.cn/prod/quantum_cloud/videos' // 视频地址
